import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingPollingService } from 'src/app/_services/ai-sourcing-polling.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { InsightsDataService } from 'src/app/_services/insights-data.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { StatsMatrixHandlerService } from 'src/app/_services/stats-matrix-handler.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-project-talent-insights',
  templateUrl: './project-talent-insights.component.html',
  styleUrl: './project-talent-insights.component.scss',
  standalone: false
})
export class ProjectTalentInsightsComponent implements OnInit, OnDestroy {

  malePercent: any = null;
  femalePercent: any = null;
  totalCandidatesCount: any = null;
  changedJobs: any = null;
  totalCandidatesCountAvailable = true;
  medianTenureInCountAvailable = true;
  totalMedianTanureCount: any = null;
  genderDataAvailable = true;
  changedJobsCountAvailable = true;
  projectnumber = '';
  projectDetails: any;
  insightsData: any;
  insightsSubject: Subject<any> = new Subject();
  @ViewChild('holdingTemplate', { static: true }) holdingTemplate: TemplateRef<any>;

  pollingSub: Subscription;
  progress = 0;
  aiSourcingStatus = '';
  circleRadius = 12;
  circumference = 2 * Math.PI * this.circleRadius;

  subs: Subscription[] = [];

  hasJobDemand = false;
  combinedAggregates: any = {};
  combinedLocation: any[] = [];
  combinedJobtitle: any[] = [];
  combinedSkills: any[] = [];
  combinedIndustry: any[] = [];
  jobDemandCount = '';
  medianSalary = '';
  currencyData: any[] = [];
  target_currency_rate = 1;
  target_fav_icon = 'fa-dollar-sign';
  currency = 'USD';
  currency_symbol = '$';

  constructor(
    private aggregationService: AggregationService,
    private localstorageService: LocalStorageService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private aiSourcingService: AiSourcingService,
    private personSearchService: PersonSearchService,
    private route: ActivatedRoute,
    private router: Router,
    private pollingService: AiSourcingPollingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private insightsDataService: InsightsDataService,
    private modalService: NgbModal,
    private talentInsightsService: TalentInsightsService,
    private filterDataHandlerService: FilterDataHandlerService,
    private aggService: AggregationService
  ) {}

  ngOnInit(): void {
    // id comes from parent shell route /:id
    this.projectnumber = this.route.snapshot.parent?.paramMap.get('id') ?? '';
    this.showLoader();
    this.getProjectDetails();

  }

  getProjectDetails(): void {
    this.aiSourcingService.getProjectDetails(this.projectnumber).subscribe((res: any) => {
      if (res.data.aisourcingstatus !== 'completed') {
        this.modalService.open(this.holdingTemplate, {windowClass:'button-place', size: 'lg', centered: true });
      }
      this.projectDetails = res.data;
      this.aiSourcingStatus = res.data.aisourcingstatus;

      // if (res.data.aisourcingstatus === 'started' || res.data.aisourcingstatus === 'pending') {
      //   this.pollingSub = this.pollingService.startPolling(this.projectnumber).subscribe(poll => {
      //     this.progress = poll.data?.progress !== null ? poll.data?.progress : this.progress;
      //     if (poll.data?.progress === 100) { this.getProjectDetails(); }
      //   });
      // }

      this.aiSourcingHandlerService.setProjectDetails(this.projectDetails);
      this.aiSourcingService.emitProjectDetailsEvent(this.projectDetails);
      this.aggregationService.getStatsAggsAISourcing(this.projectnumber);

      const statsUpdateSub = this.aiSourcingHandlerService.statsAIUpdateEvent.subscribe(stats => this.setMatrixStats(stats));
      this.subs.push(statsUpdateSub);
      this.getCombinedAggregates();
    });
  }

  setMatrixStats(res: any): void {
    this.totalCandidatesCountAvailable = true;
    this.genderDataAvailable = true;
    let response = res.find((el: any) => !!el?.data?.aggregations?.gender);
    const maleCount = response?.data?.aggregations?.gender?.find((g: any) => g.key === 'male')?.doc_count || 0;
    const femaleCount = response?.data?.aggregations?.gender?.find((g: any) => g.key === 'female')?.doc_count || 0;
    this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.statsMatrixHandlerService.setMatrixStaticData({ malePercent: this.malePercent, femalePercent: this.femalePercent });
    this.totalCandidatesCount = response?.data?.totalresultscount;

    response = res.find((el: any) => !!el?.data?.aggregations?.changedjobs);
    this.changedJobs = response?.data?.aggregations?.changedjobs?.doc_count;
    this.statsMatrixHandlerService.setMatrixStaticData({ changedJobs: this.changedJobs });
    this.changedJobsCountAvailable = true;

    response = res.find((el: any) => !!el?.data?.aggregations?.total_tenure_median);
    this.totalMedianTanureCount = response?.data?.aggregations?.total_tenure_median?.value;
    this.statsMatrixHandlerService.setMatrixStaticData({ totalMedianTanureCount: this.totalMedianTanureCount });
    this.medianTenureInCountAvailable = true;
  }

  showLoader(): void {
    this.totalCandidatesCountAvailable = false;
    this.medianTenureInCountAvailable = false;
    this.genderDataAvailable = false;
    this.changedJobsCountAvailable = false;
  }

  insightsEventHandler(event: any): void {
    if (event.action === 'aidata') {
      this.insightsData = event.data;
      this.insightsData['totalResultsCount'] = this.totalCandidatesCount || 0;
      this.insightsData['totalmedianTenure'] = this.totalMedianTanureCount || 0;
      this.insightsData['changedJobs'] = this.changedJobs || 0;
      this.insightsData['projectname'] = this.projectDetails.projectname;
      this.insightsData['activejobcount'] = this.jobDemandCount || '—';
      this.insightsData['salary'] = this.medianSalary || '—';
      this.insightsSubject.next(this.insightsData);
      this.aiSourcingService.emitInsightsAiEvent(event.data);
    }
  }

  getCombinedAggregates(): void {
    this.hasJobDemand = true;
    const aggReq = { aggregatetype: 'jobs_base_aggregates', aggregatescount: 5 };
    this.aiSourcingService.getTotalAISourcingAggs(this.projectnumber, aggReq).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      if (this.combinedIndustry?.length > 0 || this.combinedSkills?.length > 0 ||
          this.combinedJobtitle?.length > 0 || this.combinedLocation?.length > 0) {
        this.getCurrency();
      } else {
        this.jobDemandCount = '';
        this.medianSalary = '';
        this.hasJobDemand = false;
      }
    });
  }

  getJobsAggregates(): void {
    const payload = {
      aggregatetype: 'median_salary',
      startindex: 0,
      resultsize: 10,
      locations: _.pluck(this.combinedLocation, 'key'),
      skills: _.pluck(this.combinedSkills, 'key'),
      jobtitles: _.pluck(this.combinedJobtitle, 'key'),
      industries: _.pluck(this.combinedIndustry, 'key'),
    };
    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['median_salary'];
      this.hasJobDemand = false;
      this.jobDemandCount = tempData?.job_demand?.doc_count != 0 ? this.formatNumberToIndianFormat(tempData?.job_demand?.doc_count) || '' : '';
      if (this.target_fav_icon === 'fa-money-bill') {
        this.medianSalary = tempData?.median_salary_max
          ? `${this.currency} ${this.formatNumber(tempData.median_salary_min?.value * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(tempData.median_salary_max.value * this.target_currency_rate)}`
          : '0';
      } else {
        this.medianSalary = tempData?.median_salary_max
          ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(tempData.median_salary_min?.value * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(tempData.median_salary_max.value * this.target_currency_rate)}`
          : '0';
      }
      if (tempData?.median_salary_max?.value == null && tempData?.median_salary_min?.value == null) {
        this.medianSalary = '';
      }
      if (this.insightsData) {
        this.insightsData['activejobcount'] = this.jobDemandCount;
        this.insightsData['salary'] = this.medianSalary;
        this.insightsSubject.next(this.insightsData);
      }
    });
  }

  getCurrency(): void {
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      if (this.projectDetails?.location) {
        const payload = { locations: this.projectDetails.location };
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageService.setItem('insightsjobCurrency', res.data.base_currency);
            this.localstorageService.setItem('currencyCountry', res.data.country_name);
            if (res.data.base_currency) {
              const selected = this.currencyData.find((x: any) => x.target_currency === res.data.base_currency);
              if (selected) {
                this.target_currency_rate = selected.rate;
                this.currency = selected.target_currency;
                this.target_fav_icon = selected.target_currency_fav_icon;
                this.currency_symbol = selected.target_currency_symbol;
              }
            }
          }
          this.getJobsAggregates();
        });
      } else {
        const currency = this.localstorageService.getItem('insightsjobCurrency');
        if (currency) {
          const selected = this.currencyData.find((x: any) => x.target_currency === currency);
          if (selected) {
            this.target_currency_rate = selected.rate;
            this.currency = selected.target_currency;
            this.target_fav_icon = selected.target_currency_fav_icon;
            this.currency_symbol = selected.target_currency_symbol;
          }
        }
        this.getJobsAggregates();
      }
    });
  }

  chipCleanUp(value: any): string {
    const normalize = (item: any): string => {
      if (item == null) return '';
      let text = typeof item === 'string' ? item
        : typeof item === 'object' ? (item.chipkey || item.key || item.value || '')
        : String(item);
      return text.includes('.aisearch') ? text.split('.aisearch')[0] : text;
    };
    if (Array.isArray(value)) return value.map(normalize).filter(Boolean).join(', ');
    if (typeof value === 'string') return value.split(',').map((s: string) => normalize(s.trim())).filter(Boolean).join(', ');
    return normalize(value);
  }

  formatNumberToIndianFormat(number: any): string {
    if (!number) return '0';
    const suffixes = ['', 'K+', 'M+', 'B+', 'T+'];
    for (const suffix of suffixes) {
      if (Math.abs(number) < 1000) return Math.floor(number) + suffix;
      number /= 1000;
    }
    return Math.floor(number) + 'T';
  }

  formatNumber(number: number): string | number {
    if (!number) return 0;
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let index = 0;
    while (Math.abs(number) >= 1000 && index < suffixes.length - 1) { number /= 1000; index++; }
    return Math.round(number) + suffixes[index];
  }

  getFormattedTenureForMatrix(tenure: number): string {
    if (tenure == null) return '0';
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    const span = (t: string): string => { const s = document.createElement('span'); s.className = 'median-tenure-text-size'; s.innerHTML = t; return s.outerHTML; };
    if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths === 12) return `${totalYears + 1} ${span(totalYears === 0 ? 'Yr' : 'Yrs')}`;
      return `${totalYears} ${span(totalYears === 1 ? 'Yr' : 'Yrs')} ${totalMonths} ${span('Mths')}`;
    }
    if (totalYears > 0) return `${totalYears} ${span(totalYears === 1 ? 'Yr' : 'Yrs')}`;
    if (totalMonths > 0) return totalMonths === 12 ? `1 ${span('Yr')}` : `${totalMonths} ${span('Mths')}`;
    return '';
  }

  get strokeDashOffset(): number {
    return this.circumference * (1 - this.progress / 100);
  }

  dismiss(): void { this.modalService.dismissAll(); }

  ngOnDestroy(): void {
    this.pollingSub?.unsubscribe();
    this.subs.forEach(s => s.unsubscribe());
  }
}
